module.exports = "https://cdn.dove.it/_next/static/public/assets/work-with-us/hero-mobile.f48f84d250190c139856343bc78445f9.jpg";